import { SeoPage, CtaInline } from './SeoLayout';
import { BUSINESS, getLocalBusinessSchema, getBreadcrumbSchema } from '../../data/businessInfo';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQS = [
  {
    q: 'Welche Malerarbeiten übernehmen Sie in Dormagen?',
    a: 'Wir übernehmen klassische Maler- und Renovierungsarbeiten für Privat- und Gewerbekunden: Wand- und Deckenanstrich, Tapezieren, Fassadenarbeiten, Lackier- und Spachtelarbeiten, Trockenbau sowie kleinere Boden- und Renovierungsarbeiten. Wir arbeiten sowohl bei bewohnten Wohnungen als auch bei Renovierungen zwischen Auszug und Einzug.'
  },
  {
    q: 'In welchen Städten und Stadtteilen sind Sie tätig?',
    a: 'Unser Hauptsitz ist in Dormagen (41539). Wir arbeiten regelmäßig in ganz Dormagen inkl. Zons, Nievenheim, Delhoven, Hackenbroich, Stürzelberg, Straberg, Delrath, Gohr, Rheinfeld und Horrem. Zusätzlich bedienen wir Aufträge in Neuss, Köln, Düsseldorf, Leverkusen, Monheim am Rhein, Grevenbroich und Meerbusch.'
  },
  {
    q: 'Wie kann ich ein Angebot anfragen?',
    a: 'Am schnellsten telefonisch unter 02133 7787688. Sie erreichen uns werktags. Alternativ können Sie über unser Buchungssystem einen kostenlosen Besichtigungstermin online reservieren – wir kommen dann zur vereinbarten Zeit vor Ort und erstellen ein transparentes Festpreis-Angebot.'
  },
  {
    q: 'Wie läuft ein typischer Auftrag ab?',
    a: 'In fünf Schritten: 1. Anfrage per Telefon oder Kalenderbuchung. 2. Kostenlose Besichtigung vor Ort (meist innerhalb weniger Tage). 3. Schriftliches Angebot mit Festpreis. 4. Terminvereinbarung und Ausführung durch unser Team. 5. Gemeinsame Übergabe und Endreinigung. Auf Wunsch stellen wir alle Rechnungen und Nachweise digital bereit.'
  },
  {
    q: 'Ist die Besichtigung wirklich kostenlos?',
    a: 'Ja. Die Erstbesichtigung inkl. Aufmaß und einem schriftlichen Angebot ist für Sie kostenfrei und unverbindlich. Sie zahlen erst, wenn Sie das Angebot annehmen und wir mit den Arbeiten beginnen.'
  },
  {
    q: 'Was kostet ein Zimmer streichen ungefähr?',
    a: 'Als grobe Orientierung: Ein einfacher Wand- und Deckenanstrich in einem 15–20 m² Raum liegt üblicherweise im niedrigen dreistelligen Bereich – abhängig vom Untergrund, der Anzahl der Anstriche und der Farbwahl. Ein exakter Festpreis wird immer erst nach Besichtigung genannt, damit es keine unangenehmen Überraschungen gibt. Nutzen Sie gerne unsere Kostenschätzung online für einen ersten unverbindlichen Richtwert.'
  },
  {
    q: 'Wie schnell können Sie mit den Arbeiten beginnen?',
    a: 'In der Regel innerhalb von 1–2 Wochen nach Auftragsbestätigung. Bei akuten Fällen (z. B. Wohnungsübergabe, Wasserschaden, kurzfristige Renovierung) versuchen wir kurzfristigere Termine zu ermöglichen – sprechen Sie uns direkt an.'
  },
  {
    q: 'Bringen Sie Farbe und Material selbst mit?',
    a: 'Ja. Wir arbeiten mit hochwertigen Farben und Materialien und liefern diese komplett mit. Wenn Sie eine ganz bestimmte Farbe oder Marke wünschen, teilen Sie uns das gerne bei der Besichtigung mit – wir richten uns nach Ihren Vorgaben und rechnen Materialkosten transparent ab.'
  },
  {
    q: 'Muss ich die Möbel vorher wegräumen?',
    a: 'Kleinere Umräum- und Abdeckarbeiten übernehmen wir standardmäßig. Wenn Möbel komplett aus dem Raum getragen werden müssen (z. B. bei Bodenverlegung), besprechen wir das im Angebot – auf Wunsch übernehmen wir das gegen einen fairen Aufpreis.'
  },
  {
    q: 'Streichen Sie auch Fassaden und Außenbereiche?',
    a: 'Ja. Wir übernehmen Fassadenanstriche, Sockelanstriche, Balkone, Zaunelemente und ähnliche Außenarbeiten. Die Ausführung erfolgt witterungsabhängig – wir planen den Termin so, dass Trocknungszeiten und Wetter passen.'
  },
  {
    q: 'Bekomme ich einen Festpreis oder wird nach Stunden abgerechnet?',
    a: 'Standard ist ein schriftlicher Festpreis nach Besichtigung. So wissen Sie vorher, was auf Sie zukommt. Nur bei Aufträgen mit unklarem Umfang (z. B. teils versteckte Schäden hinter Tapeten) arbeiten wir alternativ mit einem Stundensatz und ausführlichem Nachweis.'
  },
  {
    q: 'Wie funktioniert die Bezahlung?',
    a: 'Sie erhalten nach Abschluss der Arbeiten eine ordnungsgemäße Rechnung. Zahlung ist per Überweisung möglich. Größere Aufträge können in Teilzahlungen (Anzahlung, Zwischenstand, Schlusszahlung) abgerechnet werden – das legen wir vor Baubeginn schriftlich fest.'
  },
  {
    q: 'Kann ich die Malerarbeiten steuerlich absetzen?',
    a: 'Als Privatperson können Sie in Deutschland i. d. R. 20 % der Arbeitskosten (nicht Materialkosten) als „Handwerkerleistung im Haushalt" nach § 35a EStG steuerlich geltend machen (max. 1.200 € pro Jahr). Voraussetzung: ordnungsgemäße Rechnung und Überweisung. Wir weisen die Arbeitskosten auf der Rechnung separat aus. Verbindlich klären sollten Sie das mit Ihrem Steuerberater.'
  },
  {
    q: 'Arbeiten Sie auch für Vermieter und Immobilienverwaltungen?',
    a: 'Ja. Wir übernehmen regelmäßig Aufträge für Vermieter, Hausverwaltungen und Wohnungsgesellschaften – z. B. Renovierungen zwischen zwei Mietverhältnissen, Wohnungsübergaben, Fluranstriche im Treppenhaus oder komplette Objektrenovierungen. Auf Wunsch stellen wir Rechnungen direkt an die Verwaltung.'
  },
  {
    q: 'Geben Sie Garantie auf die Arbeiten?',
    a: 'Auf Handwerkerleistungen gilt in Deutschland die gesetzliche Gewährleistung nach BGB. Bei ordnungsgemäßer Ausführung und Nutzung sind das für Bauleistungen üblicherweise 5 Jahre. Sollten trotz sorgfältiger Arbeit einmal Mängel auftreten, melden Sie sich – wir kümmern uns.'
  }
];

export default function FaqPage() {
  const [open, setOpen] = useState(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a }
    }))
  };

  return (
    <SeoPage
      title="Häufige Fragen zu Malerarbeiten in Dormagen | FarbWelt Maler Express Service"
      description="Antworten zu Kosten, Ablauf, Terminen und Leistungen unseres Malerbetriebs in Dormagen und Umgebung. Von Wohnungsübergabe bis Fassadenanstrich – transparent erklärt."
      canonicalPath="/faq"
      kicker="Häufige Fragen"
      heroTitle="Ihre Fragen. Ehrliche Antworten."
      heroSubtitle="Kosten, Ablauf, Termine, Garantien – wir haben die häufigsten Fragen unserer Kunden aus Dormagen und Umgebung zusammengetragen und offen beantwortet."
      jsonLd={[
        getLocalBusinessSchema(),
        faqSchema,
        getBreadcrumbSchema([
          { name: 'Startseite', item: '/' },
          { name: 'FAQ', item: '/faq' }
        ])
      ]}
    >
      <div className="not-prose space-y-3">
        {FAQS.map((item, i) => (
          <details
            key={i}
            open={open === i}
            onToggle={(e) => e.target.open && setOpen(i)}
            className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#9B1B30]/50 transition-colors"
          >
            <summary className="cursor-pointer p-5 flex items-center justify-between gap-4 font-semibold text-[#1A1A1A] list-none">
              <span>{item.q}</span>
              <ChevronDown className="w-5 h-5 text-[#9B1B30] flex-shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <div className="px-5 pb-5 text-gray-700 leading-relaxed">
              {item.a}
            </div>
          </details>
        ))}
      </div>

      <CtaInline text="Ihre Frage ist nicht dabei?" />
      <p className="text-gray-600">
        Rufen Sie uns direkt an unter <a href={`tel:${BUSINESS.phone}`} className="text-[#9B1B30] font-semibold">{BUSINESS.phoneDisplay}</a>{' '}
        oder schreiben Sie an <a href={`mailto:${BUSINESS.email}`} className="text-[#9B1B30] font-semibold">{BUSINESS.email}</a>.
        Wir melden uns werktags in der Regel am selben Tag zurück.
      </p>
    </SeoPage>
  );
}
